<div class="container message-container">
  <div class="message container mt-50">
    <div class="infotmation-container d-flex justify-content-start flex-column">
      <h1 class="text-start">
        Erro de autenticação
      </h1>
      @if (motivosNaoElegivel.length) {
        <!-- Fluxo do requerimento: pessoa não elegível (tp_elegibilidade N), com os motivos da API. -->
        <ul class="info-text motivos">
          @for (motivo of motivosNaoElegivel; track $index) {
            <li>{{ motivo }}</li>
          }
        </ul>
      } @else {
        <p class="info-text">
          Token de acesso não fornecido ou inválido.
        </p>
      }
      <div class="contact mt-4">
      <img src="assets/images/icons/fi_phone.svg" alt="phone icon">
        <p>Central de Atendimento: <strong>0800 012 7173</strong> (exceto para DDD 11) e <strong>11 3065-3000</strong></p>
      </div>
      <div class="contact">
      <img src="assets/images/icons/fi_mail.svg" alt="phone icon">
        <p>E-mail: <strong>atendimento@vivest.com.br</strong></p>
      </div>
    </div>
  </div>
</div>
